import React from "react";
import { Box, Typography, Button } from "app/material-framework/materialComponents";

export function ContinueConversationPrompt({ open, onYes, onNo }) {
  if (!open) return null;
  return (
    <Box
      sx={{
        width: "100%",
        p: 1,
        bgcolor: "rgba(202, 36, 32, 0.85)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography variant="body2" sx={{ color: "#FFFFFF" }}>
        Your next query will be considered in the context of this conversation. Start a new conversation instead?
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 1,
          paddingX: 2
        }}
      >
        <Button
          variant="outlined"
          size="small"
          sx={{
            bgcolor: "#FFFFFF",
            color: "rgba(202, 36, 32, 0.85)",
            "&:hover": { bgcolor: "rgba(202, 36, 32, 0.85)", color: "#FFFFFF", borderColor: "#F5F5F5" },
          }}
          onClick={onYes}
        >
          Yes
        </Button>
        <Button
          variant="outlined"
          size="small"
          sx={{
            bgcolor: "#FFFFFF",
            color: "rgba(202, 36, 32, 0.85)",
            "&:hover": { bgcolor: "rgba(202, 36, 32, 0.85)", color: "#FFFFFF", borderColor: "#F5F5F5" },
          }}
          onClick={onNo}
        >
          No
        </Button>
      </Box>
    </Box>
  );
}
